import React from "react";
import SectionTwoImageMobile from "../../Assets/Images/universal-life-mobile-img.png";
import { Container } from "reactstrap";
import PlusWhiteIcon from "../../Assets/Images/plus-blue.svg";
import UniversalImage from "../../Assets/Images/universal-life-img.png";
import { Link } from "react-router-dom";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const UniversalLife = ({ isScrollable, sectionActive }) => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div
        className={`${!isScrollable ? "item" : ""} ${
          sectionActive ? "active-container" : ""
        }`}
      >
        <div className="w-full flex  gap-8 lg:flex-row flex-col-reverse justify-between lg:items-center">
          <div className="mt-2 mb-4 lg:pl-0 pl-4 our-prod-tab-content  max-w-[408px]">
            {/* <h3
              className="lg:text-[24px] text-[16px]  font-semibold mb-2 lg:leading-[28px] leading-[20px]"
              id="UniversalLife"
            >
              {translations.universalLifeHeading}
            </h3> */}
            <p className="text-[14px] mb-3 extra-para-vs">
             <span className="font-bold">{translations.universalLifeDescriptionBold}</span> {translations.universalLifeDescription}
            </p>
            <div className="flex gap-3 lg:mt-9 mt-4 ">
              <Link
                to="/universal-life-insurance"
                className="gotofaqbtn flex text-[#0D4248] font-bold border border-[#0D4248] border-solid rounded-full extra-btn-font text-sm px-5 text-center gotofaqbtn hover:bg-[#6750a4] hover:bg-opacity-[0.08]"
              >
                <img src={PlusWhiteIcon} className="mr-2" alt="Plus Icon" />{" "}
                {translations.productMoreButton}
              </Link>
              <Link
                to="/compare-plans"
                className="flex text-[#0D4248] font-bold border border-[#0D4248] border-solid rounded-full text-sm px-5 extra-btn-font text-center gotofaqbtn hover:bg-[#6750a4] hover:bg-opacity-[0.08]"
              >
                {translations.productCompareButton}
              </Link>
            </div>
          </div>
          <div className="product-right-img">
            <div className="hidden lg:block">
              <img src={UniversalImage} alt="Universal" />
            </div>
            <div className="mt-4 -mr-4 lg:hidden flex justify-center">
              <img
                src={SectionTwoImageMobile}
                alt="section-two-image-mobile"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UniversalLife;
